import React from 'react'
import Title from '../layouts/Title'
import { projectOne, projectTwo, projectThree, projectFour, projectFive } from "../../assets/index";
import ProjectsCard from './ProjectsCard';

const Projects = () => {
  return (
    <section
      id="projects"
      className="w-full py-20 border-b-[1px] border-b-black"
    >
      <div className="flex justify-center items-center text-center">
        <Title
          title="Check these out on my github"
          des="My Projects"
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-14">
        <ProjectsCard
          title="Medapp - Mobile App"
          des="Telemedicine application that allows you to find qualified doctors of different specialties and book an appointment"
          src={projectOne}
          githubLink="#"
          websiteLink="https://play.google.com/store/apps/details?id=com.company.medapp"
        />
        <ProjectsCard
          title="Erna - Website"
          des="Showcase site of an consulting agency which monitors and supports anyone wishing to carry out a study project abroad."
          src={projectTwo}
          githubLink="#"
          websiteLink="https://erna.agency/"
        />
        <ProjectsCard
          title="GEOSM - GIS"
          des="Design and development of a web-based mapping system allowing the visualization and analysis of geospatial data for urban management and infrastructure."
          src={projectThree}
          githubLink="#"
          websiteLink="https://puc.position.cm/"

        />
        <ProjectsCard
          title="Gabon Daily News - Media news"
          des="Development and maintenance of a web-based information system Gabon Daily News (GDN) which is a political, social, and cultural news media."
          src={projectFour}
          githubLink="#"
          websiteLink="https://fr.gabondailynews.com/public/index.php/fr/home"
        />
        <ProjectsCard
          title="Urban Platform - PDC"
          des="Development and maintenance of a web system for sharing and using geographical data on urban projects in Cameroon."
          src={projectFive}
          githubLink="#"
          websiteLink="https://plateforme-urbaine.cm/"
        />
      </div>
    </section>
  );
}

export default Projects